module.exports = __webpack_public_path__ + "assets/img/stage-ca26220f.png";